export const CONTACTS = {
    github: "https://github.com/goshy29",
    linkedin: "https://www.linkedin.com/in/georgi-dobromirov-aa3946280/",
    email: "georgi.dobromirov@gmail.com",
};

export const ABOUT = {
    about_me: `
        GEORGI DOBROMIROV

        Email: georgi.dobromirov@gmail.com
        LinkedIn: https://www.linkedin.com/in/georgi-dobromirov-aa3946280/
        GitHub: https://github.com/goshy29

        Hello! My name is Georgi Dobromirov and I am graduate of the University of Economics - Varna, where I earned my bachelor's degree in Informatics. I have years of experience as a software developer. In real life I am a complex person who always challenges myself with different things and I try to bring this same complexity to my work. On this site, you will find a collection of well-designed projects built with React, Next.js, and Angular, each configured to communicate with different databases. I have combined these technologies to create several React and Next.js projects with Java (Spring) and Node (Express.js) backends. Each project includes description, some other details, GitHub repository link, everything you need to start the projects locally. I will be glad if you connect with me.

        WORK EXPERIENCE
        Senior Software Developer
        Tonegan Ltd, Dobrich (Dec 2015 - Present)
        Development of Business Software Products ‑ Enterprise Resource Planning (ERP) solutions.
        • Participation in the development and maintenance of a modularly organized ERP system with logical division of business processes(Production, Sales, Warehouse, Accounting, VAT, etc.).
        • Phased implementation and configuration of ERP modules according to customer needs, with flexibility for expansion.
        • Participation in custom software development, including specific modules for customer production and sales activities.
        • Integration of mobile solutions for working on the go and managing sales and deliveries on site at the customer.
        • Active role in expanding the functionality of the ERP system by creating additional tools and functionalities.

        EDUCATION
        Barchelor's degree "Informatics" (Oct 2011 - Sep 2015)
        University of Economics, Varna

        SKILLS
        SQL (Experienced)
        Relational DB (Experienced)
        Delphi (Experienced)
        Object Oriented Programming (Skillful)
        Java, IntelliJ IDEA (Skillful)
        JavaScript (Skillful)
        English (Experienced)
    `
}